export const API_URL = import.meta.env.VITE_API_URL;

export const USER = {
  LOGIN: `${API_URL}/users/login`,
  PROFILE: `${API_URL}/users/:id`,
  RESET_PASSWORD: `${API_URL}/users/resetpassword`,
};

export const BANNER = `${API_URL}/banners/web_live_scoring_free`;

export const LIVESCORING_BANNER = `${API_URL}/banners/web_center_live_scoring`;

export const BOWLING_CENTERS = {
  ALL: `${API_URL}/bowlingcenters`,
  SINGLE: `${API_URL}/bowlingcenters/:uuid`,
};

export const LIVESCORING = {
  LIVE: `wss://${API_URL}/livescoring`,
  FINISHED: `/bowlingcenters/:uuid/completed/:page`,
  SEARCH_FINISHED: `/scorecards/blocks/search`,
  TOP_SCORES: `/bowlingcenters/:uuid/leaderboards`,
};
